import React, { Component } from 'react';
import Slider from 'react-slick';
import MaskBackground from '../../../assets/images/masksBackground.png';

let Banners = null;
let self;

const descriptionContainer = (htmlString) => {
  return {__html: htmlString};
};

class Background extends Component {

  state = {
    color: "colorDark",
    colorbutton: "colorButtonDark",
    showMobileNav: false,
    classMenuBar: ""
  }

  settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    onInit: this.firstSlide,
    afterChange: this.changeSlide,
  };

  componentDidMount() {
    self = this;
    window.addEventListener("scroll", this.handleScroll);
  }
  
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll=()=>{
    if (window.pageYOffset > 200) {
        if(!this.state.classMenuBar){
          this.setState({ classMenuBar: "menubar--dark-blue" });   
        }
    } else {
        if(this.state.classMenuBar){
          this.setState({ classMenuBar: "" });
        }
    }
   
  }

  firstSlide()  {
    if(Banners.length !== 0) {
      if(Banners[0].background_type === 1 || Banners[0].background_type === 3){
        self.setState({color: "colorDark"})
        self.setState({colorbutton: "colorButtonDark"})
      } else {
        self.setState({color: "colorLight"})
        self.setState({colorbutton: "colorButtonLight"})
      }
    }
  }

  changeSlide(e)  {
    if(Banners.length !== 0) {
      if(Banners[e].background_type === 1 || Banners[e].background_type === 3){
        self.setState({color: "colorDark"})
        self.setState({colorbutton: "colorButtonDark"})
      } else {
        self.setState({color: "colorLight"})
        self.setState({colorbutton: "colorButtonLight"})
      }
    }
  }

  toggleMobileNav = () => {
    this.setState(prevState => ({ showMobileNav: !prevState.showMobileNav }));
  }

  render () {
    const {
      banners,
      loginUrl,
      logo,
      menuItems,
      backgroundImage,
      menuColor
    } = this.props;

    Banners = banners;

    const hasBanners = !!banners && !!banners.length;

    const {
      color,
      colorbutton,
      showMobileNav,
      classMenuBar
    }= this.state;

    let bgColor;
    let textColor;
    let linkColor;

    return (
      <div
        className="background-container"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className={`header-container ${showMobileNav ? 'mobile-active' : ''}`}>
          <div className="header">
            <span className="header-hamburger" onClick={this.toggleMobileNav}>
              <span className={`header-hamburger-bar ${hasBanners ? color : menuColor} ${classMenuBar}`}></span>
              <span className={`header-hamburger-bar ${hasBanners ? color : menuColor} ${classMenuBar}`}></span>
              <span className={`header-hamburger-bar ${hasBanners ? color : menuColor} ${classMenuBar}`}></span>
            </span>
            <a className="logo-wrapper" href="/">
              <div className="header-logo-container">
                <img className="header-logo" src={logo} alt="FIU Logo" />
              </div>
            </a>
            <div className="header-navbar" >
              {menuItems.map((item, index) => (
                item.hidden === 0 && <a
                  key={`menuItem-${index}`}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className= {`header-link nav-item ${hasBanners ? color : menuColor}`}>
                  <div className={hasBanners ? color : menuColor}>{item.label}</div>
                </a>
              ))}
    
              <a
                className={`header-link login-button login-link ${colorbutton}`}
                href={loginUrl}
                target="_top"
                rel="noopener noreferrer"
              >
                <div>Login to MyFIU</div>
              </a>
            </div>
          </div>
          <div className="login-link-container">
            <a className="login-link" href={loginUrl} target="_top" rel="noopener noreferrer">
              <div>Login to MyFIU</div>
            </a>
          </div>
        </div>
              
        {banners &&
          <Slider className="slider-section" {...this.settings}>
            {banners && banners.map((banner, index) => {
              if (banner.background_type === 1) {
                bgColor = '#ededec';
                textColor = 'colorDark';
                linkColor = 'gold';
              } else if (banner.background_type === 2) {
                bgColor = '#0d1f3f';
                textColor = 'colorLight';
                linkColor = 'gold';
              } else {
                bgColor = '#d0c195';
                textColor = 'colorDark';
                linkColor = 'white';
              }

              return (
                <div key={`slideItem-${index}`}>
                  <div className="slide">
                    <div
                      className="slide"
                      style={{
                        backgroundImage: `url(${MaskBackground})`,
                        backgroundColor: `${bgColor}`,
                      }}
                    >
                      <div className="banner-content-wrapper">
                        <div id={`parapraph-${index}`} className={`banner-content ${textColor} ${linkColor}`}>
                          {banner.content && <div dangerouslySetInnerHTML={descriptionContainer(banner.content)} />}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </Slider>
        }
      </div>
    )
  }
}

export default Background;



// WEBPACK FOOTER //
// ./src/app/screens/landing/background.js